<template>
  <section>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="40"
          align="center">
          <template>
            <div class="flex-algin ">
              <span >
                <font-awesome-icon icon="dollar-sign" />
              </span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="quote_dt"
          width="100"
          label="Created">
          <template #default="{ row }">
            <div class="text">
              <span>{{ row.quote_dt.split(" ")[0] }}</span><br>

              <span> {{ row.quote_dt.split(" ")[1] }}</span>
              <p class="channel">{{row.source_language}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="85"
          prop="id"
        >
          <template #default="{ row }">
            <span class="button-border table-type">{{row.type_language}}</span>
            <div
              class="flex-center margin-top-flex"
              :class="{'ju_center': row.company_id == 0}">
              <span
                v-if="row.company_id&&row.product_id!=80"
                v-tooltip="row.company_language"
                class="icon icon-content"
              >
                <img
                  :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                >
              </span>
              <span>
                <span
                  v-tooltip="row.class_language"
                  class="icon icon-content"
                >
                  <font-awesome-icon
                    v-if="row.class_id&&row.product_id!=80"
                    :icon="getOptionName('iconOptions', row.class_id)" />
                  <font-awesome-icon
                    v-else
                    icon="cube" />
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200"
          label="Plan Name">
          <template #default="{ row }">
            <div
              class="flex-algin"
              @click="rowClick(row)">
              <router-link
                class="showLick plan"
                :class="{'italic': row.plan_id === null}"
                :to="rowClickFn(row)">
                {{ row.plan }}
              </router-link>
              <!-- <p>{{row.plan}}</p> -->
              <p  class="liter-text">{{row.quotation_number}}</p>
            </div>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="insurer"-->
        <!--          label="Insurer"></el-table-column>-->
        <el-table-column
          width="100"
          prop="price"
          label="Price">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>{{row.price}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="contact_nm"
          label="Account">
          <template #default="{ row }">
            <div class="flex-algin">
              <span
                :class="{
                  'unname': row.contact_nm.trim() == ''
                }">
                {{ row.contact_nm.trim()?  row.contact_nm : 'Unnamed Account'}}
              </span>
              <p  class="liter-text"> {{ row.phone_no }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="referrer_nm"
          label="Referrer">
          <template #default="{ row }">
            <span
              v-if="row.referrer_id != 0 && row.referrer_nm.trim() === ''"
              class="unname">Unnamed</span>
            <span v-if="row.referrer_id != 0">{{ row.referrer_nm }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          label="Period">
          <template #default="{row}">
            <div
              v-if="row.policy_period"
              class="flex-column">
              <span>{{row.policy_period.split(" - ")[0]}} - </span>
              <span>{{row.policy_period.split(" - ")[1]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="stts_language"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>
                <span
                  class="span-status"
                  :class="{
                    'yellow-dark': [4, 7].includes(row.stts),
                    'blue': [1, 5].includes(row.stts),
                    'red': [6].includes(row.stts),
                    'purple': [3].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </span>
              <span
                v-for="(v,i) in row.tag_language"
                :key="i">
                <span
                  class="span-options"
                  :class="{
                    'red': [1].includes(v.id),
                    'gray': [2,4].includes(v.id)
                  }">
                  {{ v.name }}
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getOrderList} from '@/api/order'

export default {
  name: '',
  mixins: [MixinOptions],
  data () {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      tableData:[]
    }
  },
  computed:{
    options(){
      return this.$route.query || null
    }
  },
  watch:{
    property: {
      immediate: true,
      handler() {
        this.network().getOrderList()
      }
    },
  },
  methods: {
    rowClick(row) {
      let product_id = row.product_id
      if(row.product_id==80)
        product_id = row.class_id
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: product_id
        }
      })
    },
    // 新标签打开链接
    rowClickFn(row){
      return({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: row.product_id
        }
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getOrderList()
    },
    network() {
      return {
        getOrderList: async () => {
          const { data } = await getOrderList({
            class_id: [this.options.class_id],
            company_id: [this.options.company_id],
            plan_id: this.options.plan_id,
            page: this.pageConfig.currentPage,
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.transparent{
  margin-top: 15px;
}
/deep/.el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
}
/deep/.tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    color: #24292E!important;
  }
}
.showLick{
  color: #24292E;
  text-decoration: none;
  font-weight: 600;
  &:hover{
    color:  #0366D6;
  }
  &.italic{
    font-style: italic;
  }
  &.plan{
    word-break: normal;
  }
}

.channel{
  color: #586069;
  font-weight: 600;
}
/deep/.el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      .cell{
        line-height: 23px;
        position: relative;
        height: inherit;
        padding: 0;
      }
    }
  }
  th{
    .cell{
      padding: 0;
    }
  }
}
.span-status {
    display: inline-block;
    margin-right: 15px;
    padding: 5px 10px;
    border-radius: 12px;
    font-size: 12px;
    line-height: 14px;
    color: white;
    font-weight: 500;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09,
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
}
.span-options {
  display: inline-block;
  padding: 0px 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #FFFFFF;
  border-radius: 100px;
  max-width: 140px;
  word-break:keep-all;
  white-space:nowrap;
  height: 18px;
  min-height: 18px !important;
  border: 1px solid;
  &.gray {
    border-color: #586069;
    color: #586069;
  }
  &.red {
    border-color: #D73A49;
    color: #D73A49;
  }
}
.button-border{
  display: inline-block;
  padding: 0px 10px;
  height: auto;
  font-size: 12px;
  border-radius: 50px;
  border: 1px solid #E1E4E8;
  color: #24292E;
  background: white;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
  &.red {
    border-color: #D73A49;
    color: #D73A49;
  }
  &.gray {
    border-color: #586069;
    color: #586069;
  }
}
.table-type{
  white-space: nowrap;
}
.margin-top-flex{
  margin-top: 5px;
  .icon{
    margin-right: 10px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e1e4e8;
  }
}
.ju_center{
  justify-content: center;
}
.el-table{
  font-size: 12px;
  color: #24292E;
  ::v-deep .flex-algin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      height: 24px;
    }
    .unname{
      font-style: italic;
      color: #6A737D;
    }
  }
  p:first-child{
    color: #24292E;
    font-size: 14px;
    font-weight: 500;
  }
  .login-text{
    color: #24292E;
    font-family: Inter;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 17px;
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }
  .text{
    color: #24292E;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
  }
}
</style>
